if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantInput = this.querySelector('.product-info__variant-id');
        this.submitButton = this.querySelector('.product-info__submit');
        this.submitText = this.querySelector('.product-info__submit-text');
        this.variantButtons = Array.from(this.querySelectorAll('.product-info__variant'));
        this.inventoryEl = this.querySelector('.product-info__inventory');
        this.loading = false;

        this.variantButtons.forEach((button) => {
          button.addEventListener('click', this.onVariantSelect.bind(this));
        });

        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }

      onVariantSelect(evt) {
        const button = evt.currentTarget;

        this.variantButtons.forEach((btn) => {
          btn.classList.remove('product-info__variant--selected');
          btn.setAttribute('aria-checked', 'false');
        });
        button.classList.add('product-info__variant--selected');
        button.setAttribute('aria-checked', 'true');

        this.variantInput.value = button.dataset.variantId;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

        if (this.inventoryEl && button.dataset.inventoryLabel) {
          this.inventoryEl.textContent = button.dataset.inventoryLabel;
        }

        const available = button.dataset.available !== 'false';

        this.submitButton.disabled = !available;
        this.submitButton.setAttribute('aria-disabled', String(!available));
        this.submitText.textContent = available
          ? this.submitButton.dataset.addText
          : this.submitButton.dataset.soldOutText;
      }

      async onSubmit(evt) {
        evt.preventDefault();
        if (this.loading || this.submitButton.disabled) return;

        this.loading = true;
        this.submitButton.classList.add('is-loading');

        try {
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.variantInput.value, quantity: 1, sections: 'cart-drawer' }),
          });

          if (!addResponse.ok) {
            const error = await addResponse.json();
            throw new Error(error.description || 'Add to cart failed');
          }

          const addResult = await addResponse.json();
          const cart = await fetch('/cart.js').then((res) => res.json());
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, sections: addResult.sections } }));

          this.submitText.textContent = window.themeStrings.added;
          setTimeout(() => {
            this.submitText.textContent = this.submitButton.dataset.addText;
          }, 1500);
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
          this.submitButton.classList.remove('is-loading');
        }
      }
    }
  );
}
